/* eslint-disable no-useless-escape */
import { useEffect, useState, useCallback, useRef } from "react";
import { Row, Col } from "react-flexbox-grid";
import { Button, Input } from "components/core";
import { PageWrapper, InputMask } from "components";
import { useGlobalContext } from "context/GlobalContext";
import { withLoader } from "HOC";
import Typography from "@material-ui/core/Typography";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import ListSubheader from "@material-ui/core/ListSubheader";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import Divider from "@material-ui/core/Divider";
import { useHistory, useParams } from "react-router-dom";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import CardValidator from "card-validator";
import {
  STATES,
  getMessageByStatus,
  GENDERS,
  BASE_CURP,
  VERIFY,
  REGISTER,
  ASSIGNED,
  WAITING_FOR_ASSIGNMENT,
  NOT_VERIED,
  CONFIRMED_ASSISTANCE,
  VACCINATED,
} from "constants/index";
import { fetchBackend, formatterPrice, getCommissionConeckta } from "helpers";
import iconVaccine from "assets/images/auth/icons/icon-vaccine.svg";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

import Axios from "axios";

const SchemaCard = yup.object().shape({
  // amount: yup.number().required("Ingresa un monto para continuar"),
  name: yup
    .string()
    .required("Ingresa el nombre del propietario de la tarjeta"),
  number: yup
    .string()
    .test(
      "number",
      "Número de tarjeta invalido",
      (value) => CardValidator.number(value).isValid
    )
    .required("Ingresa el nombre del propietario de la tarjeta"),
  date: yup
    .string()
    .test("date", "Fecha de tarjeta invalida", (value) => {
      return CardValidator.expirationDate(value).isValid;
    })
    .required("Ingresa la fecha de la tarjeta"),
  cvc: yup
    .string()
    .test(
      "cvc",
      "CVC ingresado invalido",
      (value) => CardValidator.cvv(value).isValid
    )
    .required("Ingresa el CSV de la tarjeta"),
});

const SinglePayment = ({ setLoading }) => {
  const [currentStep, setStep] = useState(1);

  useEffect(() => {
    setLoading(false);
  }, []);

  return (
    <PageWrapper
      header={
        <Row start="xs">
          <Col md={12}>
            <Row center="xs">
              <h1>Programa de vacunación</h1>
            </Row>
          </Col>
        </Row>
      }
    >
      <>
        <FormPayment currentStep={currentStep} />
        <CompletedForm currentStep={currentStep} setStep={setStep} />
      </>
    </PageWrapper>
  );
};

export default withLoader(SinglePayment, "Cargando forma de pago");

const FormPayment = ({ currentStep, setStep }) => {
  const [amount, setAmount] = useState(0);
  const [isChargin, setCharge] = useState(false);
  const [currentVaccine, setVaccine] = useState(null);
  const [priceVaccine, setPriceVaccine] = useState(null);
  const { id } = useParams();
  const gContext = useGlobalContext();
  const history = useHistory();

  const { handleSubmit, register, errors, control, setError } = useForm({
    resolver: yupResolver(SchemaCard),
  });

  const incrementVaccineSells = async () => {
    const { error, response } = await fetchBackend({
      method: "put",
      url: `priceVaccine/increment/${priceVaccine._id}`,
      data: {},
    });

    // console.log(response);
  };

  const addRequestVaccine = async (obj) => {
    const { error, response } = await fetchBackend({
      method: "put",
      url: `vaccine/${id}`,
      data: obj,
    });

    if (!error) {
      setCharge(false);
      gContext.toggleAlert({
        message: "Solicitud de vacuna registrada con exito",
      });
      history.push(`/vacunas`);
    } else {
      setCharge(false);
      const message =
        response.data?.error ||
        "Hubo un error al intentar actualizar los datos, intente nuevamente";
      gContext.toggleAlert({
        message,
        type: "error",
      });
    }
  };

  const toPayVaccine = async (obj, data) => {
    const { error, response } = await fetchBackend({
      method: "post",
      url: "coneckta/createOrderPayment",
      data: obj,
    });

    if (!error) {
      const newData = {
        ...data,
        accountBreakdown: {
          ...data.accountBreakdown,
          transactionId: response.data.result?.id,
        },
      };
      // console.log(newData);
      await addRequestVaccine(newData);
      await incrementVaccineSells();
      gContext.toggleAlert({
        message: "Pago de vacuna registrado con exito",
      });
    } else {
      setCharge(false);
      const message =
        response.data?.error ||
        "Hubo un error al intentar realizar el pago, verifique su información";
      gContext.toggleAlert({
        message,
        type: "error",
      });
    }

    return response;
  };

  const successResponseHandler = async (token) => {
    try {
      setCharge(true);
      const { data: curpOficial } = await Axios(
        `${BASE_CURP}${currentVaccine.curp}`
      );

      // const vaccine = priceVaccine?.mount - 0.2;
      const vaccine = priceVaccine?.mount;

      const productName = "Vacuna COVID19";
      const description = "Vacuna COVID19";
      const reference = "Vacuna COVID19";

      const conecktaMetadata = {
        productName,
        description,
        reference,
        unit_price: priceVaccine?.mount,
        quantity: 1,
        conecktaId: gContext.currentUser?.conecktaId,
        token_id: token?.id,
      };

      const accountBreakdown = {
        vaccine,
        donation: 0,
        apiVerification: 0,
        commissionConeckta: getCommissionConeckta(vaccine),
        transactionId: "",
        date: new Date().getTime(),
      };

      const data = {
        curpOficial,
        accountBreakdown,
        status: WAITING_FOR_ASSIGNMENT,
      };

      // // console.log(gContext.currentUser);
      // // console.log("conecktaMetadata", conecktaMetadata);

      await toPayVaccine(conecktaMetadata, data);
      // // console.log("*************");
      // // console.log(resConeckta.data.result);
      // // console.log("*************");

      // // console.log("data", data);
      // // console.log("token", token);
    } catch (error) {
      // console.log(error);
    }

    // Do something on sucess
    // you need to send the token to the backend.
  };

  const errorResponseHandler = (error) => {
    // console.log(error);
    // Do something on error
  };

  const generateToken = (tokenParams) => {
    window.Conekta.Token.create(
      tokenParams,
      successResponseHandler,
      errorResponseHandler
    );
  };

  const onSubmit = ({ name = "", number = "", date = "", cvc = "" }) => {
    const card = {
      name,
      number,
      exp_month: date.slice(0, 2),
      exp_year: date.slice(-2),
      cvc,
    };

    // if (amount > 0) {
    const tokenParams = { card };
    // // console.log(tokenParams);
    generateToken(tokenParams);
    // } else {
    //   setError("amount", {
    //     type: "required",
    //     message: "Ingresa un monto para continuar",
    //   });
    // }
  };

  const onInputChange = async (e) => {
    setAmount(!e.target.value ? "" : parseFloat(e.target.value));
  };

  useEffect(() => {
    const getPriceVaccine = async () => {
      const { error, response } = await fetchBackend({
        url: `priceVaccine/day/${new Date().getTime()}`,
      });

      if (!error) {
        const singlePriceVaccine = response[0];
        // console.log("priceVaccine", singlePriceVaccine);
        setPriceVaccine(
          singlePriceVaccine
            ? { ...singlePriceVaccine, mount: singlePriceVaccine.mount }
            : null
        );
      } else {
        gContext.toggleAlert({
          message:
            "Hubo un error al intentar el costo de la vacuna, revisa tu conexión a internet",
          type: "error",
        });
      }
    };

    const getVaccine = async () => {
      const { error, response } = await fetchBackend({
        url: `vaccine/${id}`,
      });

      if (!error) {
        const vaccine = response[0];
        const isPaymentsVaccine = vaccine?.status !== WAITING_FOR_ASSIGNMENT;
        isPaymentsVaccine && (await getPriceVaccine());
        // console.log("currentVaccine", vaccine);
        setVaccine(vaccine);
      } else {
        gContext.toggleAlert({
          message:
            "Hubo un error al intentar obtener la información, revisa tu conexión a internet",
          type: "error",
        });
      }
    };

    id && getVaccine();
  }, [id]);

  const isAvailablePayment = priceVaccine?.units >= priceVaccine?.soldUnits;

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="w-100">
      <>
        <Row className={currentStep === 1 ? "" : "dn"}>
          <Input
            md={6}
            name="name"
            placeholder="Nombre de la tarjeta"
            ref={register}
            disabled={isChargin}
            error={errors.name?.message}
          />
          <Input
            md={6}
            name="number"
            type="number"
            placeholder="Número de tarjeta"
            ref={register}
            disabled={isChargin}
            error={errors.number?.message}
          />
          <Controller
            name="date"
            control={control}
            render={(props) => (
              <InputMask
                xs={6}
                md={6}
                name="date"
                placeholder="MM/YY"
                mask="00/00"
                value={props.value}
                disabled={isChargin}
                error={errors.date?.message}
                onChange={(date) => props.onChange(date)}
              />
            )} // props contains: onChange, onBlur and value
          />
          <Input
            xs={6}
            md={6}
            name="cvc"
            type="password"
            placeholder="CVC"
            ref={register}
            disabled={isChargin}
            error={errors.cvc?.message}
          />
          {/* <Input
            md={12}
            name="amount"
            placeholder="Monto a donar"
            type="number"
            ref={register}
            onChange={onInputChange}
            value={amount}
            disabled={isChargin}
            error={errors.amount?.message}
          /> */}
          <AccountBreakdown
            mount={priceVaccine?.mount}
            mountTotal={priceVaccine?.mount}
          />
          <Col md={12} className="mt2">
            <Button
              htmlType="submit"
              color="primary"
              size="large"
              className="w-100"
              disabled={!priceVaccine || !isAvailablePayment}
              loading={isChargin}
            >
              {!priceVaccine || !isAvailablePayment
                ? "No disponible para pago, revise más tarde"
                : "Realizar pago"}
            </Button>
          </Col>
        </Row>
      </>
    </form>
  );
};

const AccountBreakdown = ({ mount, mountTotal }) => {
  return (
    <Col md={12}>
      <Row end="xs">
        <Col md={6} className="mt3 mb3">
          <List className="w-100">
            <ListSubheader>Desglose de cuenta</ListSubheader>
            <ListItem>
              <ListItemText primary="Vacuna" />
              <ListItemSecondaryAction>
                <Typography variant="body1">{formatterPrice(mount)}</Typography>
              </ListItemSecondaryAction>
            </ListItem>
            <Divider />
            <ListItem>
              <ListItemText primary="Total" />
              <ListItemSecondaryAction>
                <Typography variant="h5">
                  {formatterPrice(mountTotal)}
                </Typography>
              </ListItemSecondaryAction>
            </ListItem>
            <Divider />
          </List>
        </Col>
      </Row>
    </Col>
  );
};

const PageListVaccine = ({ currentVaccine, setStep, currentStep }) => {
  // console.log(currentStep);
  if (currentStep !== 1) return null;

  const {
    status,
    name,
    motherLastName,
    fatherLastName,
    birthDay,
    curp,
  } = currentVaccine;

  const { color, message } = getMessageByStatus(status);

  return (
    <Row center="xs" middle="xs" className="w-100">
      <Col md={12}>
        <Row>
          <Col md={12}>
            <Row end="xs">
              <Col md={12} className="mb3">
                <List className="w-100">
                  <ListItem>
                    <ListItemText primary="Estatus" />
                    <ListItemSecondaryAction>{status}</ListItemSecondaryAction>
                  </ListItem>
                  <ListItem>
                    <ListItemText primary="Nombre" />
                    <ListItemSecondaryAction>{name}</ListItemSecondaryAction>
                  </ListItem>
                  <ListItem>
                    <ListItemText primary="Apellido paterno" />
                    <ListItemSecondaryAction>
                      {fatherLastName}
                    </ListItemSecondaryAction>
                  </ListItem>
                  <ListItem>
                    <ListItemText primary="Apellido materno" />
                    <ListItemSecondaryAction>
                      {motherLastName}
                    </ListItemSecondaryAction>
                  </ListItem>
                  <ListItem>
                    <ListItemText primary="Fecha de nacimiento" />
                    <ListItemSecondaryAction>
                      {new Date(birthDay).toLocaleDateString()}
                    </ListItemSecondaryAction>
                  </ListItem>
                  <ListItem>
                    <ListItemText primary="Curp" />
                    <ListItemSecondaryAction>{curp}</ListItemSecondaryAction>
                  </ListItem>
                </List>
              </Col>
            </Row>
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <Typography variant="body1" color={color}>
              {message}
            </Typography>
          </Col>
        </Row>
        <SectionAction {...currentVaccine} setStep={setStep} />
      </Col>
    </Row>
  );
};

const SectionAction = ({ status, setStep }) => {
  if (status !== REGISTER && status !== ASSIGNED) return null;

  const history = useHistory();
  const isRegister = status === REGISTER;
  const onClick = isRegister ? () => setStep(2) : () => setStep(3);
  const textBtn = isRegister ? "Pagar vacuna" : "Escoger";

  return (
    <Row center="xs" className="mt3 mb3">
      <Col md={12}>
        <Button
          variant="contained"
          color="primary"
          className="w-100"
          onClick={onClick}
        >
          {textBtn}
        </Button>
      </Col>
    </Row>
  );
};

const WaitingRequestVaccine = ({ status }) => {
  const history = useHistory();

  return (
    <Row center="xs" middle="xs" className="w-100 pt6">
      <Col md={12} className="mt4">
        <Row center="xs">
          <img src={iconVaccine} alt="iconVaccine" className="m-auto" />
        </Row>
        <Row center="xs">
          <Typography variant="h6" color="secondary">
            Upss. Lo sentimos aún no tienes fecha asignada.
          </Typography>
        </Row>
        <Row center="xs" className="mt2">
          <Typography variant="body2" color="textPrimary">
            Le notificaremos el avanze de su solicitud por medio de la app y/o
            correo eléctronico.
          </Typography>
        </Row>
        <Row center="xs" className="mt2">
          <Typography variant="body2" color="textPrimary">
            Tu estatus actual es &nbsp;
            {status}
          </Typography>
        </Row>
        <Row center="xs" className="mt3 mb3">
          <Button
            variant="contained"
            color="secondary"
            className="w-100"
            onClick={() => history.push("/")}
            style={{ maxWidth: 320 }}
          >
            Regresar
          </Button>
        </Row>
      </Col>
    </Row>
  );
};

const CompletedForm = ({ currentStep, status }) => {
  const history = useHistory();

  return (
    <Row
      center="xs"
      middle="xs"
      className={currentStep === 2 ? "w-100 pt6" : "dn"}
    >
      <Col md={12} className="mt4">
        <Row center="xs">
          <CheckCircleIcon color="primary" style={{ height: 94, width: 94 }} />
        </Row>
        <Row center="xs">
          <Typography variant="h6" color="secondary">
            Usted a sido registrado con en el programa de vacunación con EXITO
          </Typography>
        </Row>
        <Row center="xs" className="mt2">
          <Typography variant="body2" color="textPrimary">
            Le notificaremos el avanze de su solicitud por medio de la app y/o
            correo eléctronico.
          </Typography>
        </Row>
        <Row center="xs" className="mt2">
          <Typography variant="body2" color="textPrimary">
            Tu estatus actual es &nbsp;
            {status}
          </Typography>
        </Row>
        <Row center="xs" className="mt3 mb3">
          <Button
            variant="contained"
            color="secondary"
            className="w-100"
            onClick={() => history.push("/")}
            style={{ maxWidth: 320 }}
          >
            Regresar
          </Button>
        </Row>
      </Col>
    </Row>
  );
};
